import { AdminAgentNewsEndpoints, fetcher } from '@olagg/api-hooks';
import { AgentNewsType } from '@olagg/db-types';

const normalizeNews = (data: any): AgentNewsType => ({
    ...data,
    title_en: data.title_en ?? data.titleEn ?? null,
    title_pt: data.title_pt ?? data.titlePt ?? null,
    lead_en: data.lead_en ?? data.leadEn ?? null,
    lead_pt: data.lead_pt ?? data.leadPt ?? null,
    body_en: data.body_en ?? data.bodyEn ?? null,
    body_pt: data.body_pt ?? data.bodyPt ?? null,
    main_category: data.main_category ?? data.mainCategory ?? null,
    cover_image: data.cover_image ?? data.coverImage ?? null,
    cover_image_en: data.cover_image_en ?? data.coverImageEn ?? null,
    cover_image_pt: data.cover_image_pt ?? data.coverImagePt ?? null,
    entity_name: data.entity_name ?? data.entityName ?? null,
    tag_list: data.tag_list ?? data.tagList ?? [],
    ai_generated: data.ai_generated ?? data.aiGenerated ?? false,
    published_at: data.published_at ?? data.publishedAt ?? null,
    rejected_at: data.rejected_at ?? data.rejectedAt ?? null,
    rejection_reason: data.rejection_reason ?? data.rejectionReason ?? null,
    publication_date: data.publication_date ?? data.publicationDate ?? null,
    expiration_date: data.expiration_date ?? data.expirationDate ?? null,
    created_at: data.created_at ?? data.createdAt ?? null,
    updated_at: data.updated_at ?? data.updatedAt ?? null,
});

const useAgentNews = () => {
    const getAll = async ({ title, status, ai_generated, page, limit }: { title?: string; status?: 'draft' | 'published' | 'rejected'; ai_generated?: boolean; page: number; limit: number }) => {
        const response = await fetcher(AdminAgentNewsEndpoints.all({ title, status, ai_generated, page, limit }));
        return {
            news: response.news.map(normalizeNews),
            count: response.meta.count,
        };
    };

    const getNews = async (id: number) => {
        const response = await fetcher(AdminAgentNewsEndpoints.find(id));
        return normalizeNews(response.news);
    };

    const updateNews = async (id: number, data: any) => {
        const response = await fetcher(AdminAgentNewsEndpoints.update(id, data));
        return response.news;
    };

    const publishNews = async (id: number) => {
        const response = await fetcher(AdminAgentNewsEndpoints.publish(id));
        return response.news;
    };

    const unpublishNews = async (id: number) => {
        const response = await fetcher(AdminAgentNewsEndpoints.unpublish(id));
        return response.news;
    };

    const rejectNews = async (id: number, reason: string) => {
        const response = await fetcher(AdminAgentNewsEndpoints.reject(id, reason));
        return normalizeNews(response.news);
    };

    return {
        getAll,
        getNews,
        updateNews,
        publishNews,
        unpublishNews,
        rejectNews,
    };
};

export default useAgentNews;
